//@flow

import styled from "styled-components"
import TitleContainer from "../Shared/TitleContainer"
import DefaultTitleContent from "../Shared/TitleContent"

export const Intro = TitleContainer.extend`
  width: 718px;
  top: 144px;
  left: 24px;
  position: absolute;
  z-index: 1;
`

export const TitleContent = DefaultTitleContent.extend`
  color: #a5a5a5;
  font-size: 36px;
  font-weight: 300;
`

export const Nav = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 754px;
  top: 144px;
  right: 74px;
  z-index: 2;
  pointer-events: none;
`
export const NavItem = styled.li`
  display: flex;
  background: ${({ selected }) =>
    selected ? "rgba(71, 37, 72, 1)" : "rgba(0, 0, 0, 0.68)"};
  border-radius: 2rem;
  margin-bottom: 2rem;
  position: relative;
  flex-basis: 208px;
  height: 208px;
  pointer-events: auto;

  > * {
    filter: grayscale(
      ${({ selected, colorable }) => (selected || colorable ? 0 : 1)}
    );
  }
`

export const BodyPartIcon = styled.div`
  display: block;
  position: absolute;
  top: ${props => props.top || "0px"};
  left: ${props => props.left || "0px"};
  top: ${props => props.top || "0px"};
  height: ${props => props.height || "100px"};
  width: ${props => props.width || "100px"};
`

export const NavContent = styled.ul`
  list-style: none;
  padding-left: 252px;
  padding-right: 4rem;
  display: flex;
  flex-direction: column;
  margin: auto 0;
`

export const NavTitle = styled.h3`
  color: #fff;
  font-size: 40px;
  font-family: "din-condensed";
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: auto;
`

export const NavDescription = NavTitle.extend`
  color: #7f7f7f;
  font-size: 30px;
  text-transform: none;
  margin-bottom: auto;
  margin-top: 0;
`.withComponent("p")

export const BodyContainer = styled.div`
  height: 2318px;
  width: 676px;
  top: 108px;
  left: 50%;
  position: absolute;
  margin-left: -373px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/BodyView/UI.js